import React from 'react';
import Slider from 'react-slick';
import { css } from '@emotion/core';

import './BottomSlider.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const BottomSlider = ({ slides, advertisingBannerVersion }) => {
  const settings = {
    arrows: false,
    dots: false,
    customPaging: function(i) {
      return <button className="dot" />;
    },
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: advertisingBannerVersion !== 2 ? 3 : 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: advertisingBannerVersion !== 2 ? 3 : 2 },
      },
      {
        breakpoint: 1100,
        settings: { slidesToShow: advertisingBannerVersion !== 2 ? 3 : 2 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: advertisingBannerVersion !== 2 ? 3 : 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: advertisingBannerVersion !== 2 ? 2 : 1 },
      },
      { breakpoint: 567, settings: { slidesToShow: 1 } },
    ],
  };

  const advertisingSlider = css`
    &.version-1 {
      max-width: 94%;
      margin: 0 auto;

      padding-right: 3%;
      padding-left: 3%;
      @media screen and (min-width: 1764px) {
        padding-right: 1%;
        padding-left: 1%;
      }
    }

    &.version-1,
    &.version-2,
    &.version-3 {
      & .bottom-slider .slick-slider {
        .slick-list {
          line-height: 0.8;
          overflow: hidden;
          margin-left: ${advertisingBannerVersion !== 2
            ? 'calc(-35px + 35px/2)'
            : 'calc(-30px + 30px/2);'};
          margin-right: ${advertisingBannerVersion !== 2
            ? 'calc(-35px + 35px/2)'
            : 'calc(-30px + 30px/2);'};
          .slick-track {
            display: flex;

            & .slick-slide {
              margin: ${advertisingBannerVersion !== 2
                ? '0 calc(35px - 35px/2)'
                : '0 calc(30px - 30px/2)'};
              & div > .banner {
                display: flex !important;
                justify-content: center !important;
                border: 1px solid #d0d1d4;
                border-radius: 8px;

                & a > {
                  .img-fluid {
                    width: 100%;
                    object-fit: cover;
                    border-radius: 6px;

                    &.version-1 {
                      @media screen and (min-width: 1600px) {
                        max-width: unset;
                      }
                      max-width: 439px;
                      height: 243px;
                      @media screen and (max-width: 992px) {
                        height: 150px;
                      }
                    }
                    &.version-2 {
                      // width: 800px;
                      height: 277px;
                      @media screen and (max-width: 992px) {
                        height: 150px;
                      }
                    }
                    // &.version-3 {
                    //   @media screen and (min-width: 1600px) {
                    //     min-width: 450px;
                    //   }
                    //   max-width: 450px;
                    //   height: 249px;
                    //   @media screen and (max-width: 992px) {
                    //     height: 150px;
                    //   }
                    // }
                  }
                }
              }
            }
          }
        }
      }
    }

    &.version-2,
    &.version-3 {
      max-width: 94%;
      margin: 0 auto;
    }
    &.version-3 {
      padding-left: 2%;
      padding-right: 2%;
    }
  `;

  return (
    <div
      className={`bottom-slider-container version-${advertisingBannerVersion}`}
      css={advertisingSlider}
    >
      <div className="bottom-slider">
        <Slider {...settings}>
          {[...slides, ...slides]
            .filter(slide => !!slide.imgUrl)
            .map(slide => {
              return (
                <div key={slide.id} className="banner">
                  <a href={slide.link} style={{ width: '100%' }}>
                    <ImageDispatcher
                      src={slide.imgUrl}
                      alt={slide.seoName}
                      className={`img-fluid version-${advertisingBannerVersion}`}
                    />
                  </a>
                </div>
              );
            })}
        </Slider>
      </div>
    </div>
  );
};

export default BottomSlider;
//advertisingBannerVersion 1: 3 slides, max slide width: 439px, slide height: 243px, gap between slides: 35px;
//advertisingBannerVersion 2: 2 slides, max slide width: 749px, slide height: 259px, gap between slides: 30px;
//advertisingBannerVersion 3: 3 slides, max slide width: 450px, slide height: 249px, gap between slides: 35px;
